// extracted by mini-css-extract-plugin
export default {"fieldMappingContainer":"a977ac91187f","addAxeFieldButton":"c56a9f994405","borderBottom":"f7bd65921f74","compatibilityWarning":"dfce519f43fb","summaryFieldContainer":"dacf97a973ae"};